import React from 'react';

import ScheduleDemoSection from '../../components/common/sections/ScheduleDemoSection';
import Layout from '../../components/layout/Layout';
import Banner from '../../components/pricing/home/Banner';
import Description from '../../components/pricing/home/Description';
import Faqs from '../../components/pricing/home/Faqs';
import Flags from '../../components/pricing/home/Flags';
import Prices from '../../components/pricing/home/Prices';
import Wineries from '../../components/pricing/home/Wineries';

const PricingPage = () => (
  <Layout title="Pricing" header="light">
    <Banner />
    <Description />
    <Flags />
    <Prices />
    <Wineries />
    <Faqs />
    <ScheduleDemoSection />
  </Layout>
);

export default PricingPage;
